import '@fontsource/plus-jakarta-sans';
import React from 'react';
import '@fontsource/plus-jakarta-sans';
import ReactDOM from 'react-dom/client';
import '@fontsource/plus-jakarta-sans';
import './index.css';
import '@fontsource/plus-jakarta-sans';
import App from './App';
import '@fontsource/plus-jakarta-sans';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
